// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchBar_searchBar__TMWTY {
  grid-area: search;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  margin-right: 0.5em;
}
.SearchBar_searchBar__TMWTY .SearchBar_searchInput__Tet3F {
  border: none;
  height: 30px;
  width: 100%;
  max-width: 200px;
  border-radius: 100px;
  background: var(--background-color-3-alpha);
  color: var(--background-color-1);
  padding: 0 1em;
}
.SearchBar_searchBar__TMWTY .SearchBar_searchInput__Tet3F::placeholder {
  color: var(--background-color-1);
  font-style: italic;
}
.SearchBar_searchBar__TMWTY .SearchBar_searchInput__Tet3F:focus {
  outline: none;
}
.SearchBar_searchBar__TMWTY .SearchBar_searchInput__Tet3F.focus-visible {
  box-shadow: 0 0 0 5px var(--background-color-1-alpha);
}
.SearchBar_searchBar__TMWTY .SearchBar_searchButton__A9ZIf {
  position: absolute;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/Template/components/Menu/SearchBar.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACF;AAAE;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,2CAAA;EACA,gCAAA;EACA,cAAA;AAEJ;AADI;EACE,gCAAA;EACA,kBAAA;AAGN;AADI;EACE,aAAA;AAGN;AADI;EACE,qDAAA;AAGN;AAAE;EACE,kBAAA;EACA,QAAA;AAEJ","sourcesContent":[".searchBar {\n  grid-area: search;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: relative;\n  margin-right: 0.5em;\n  .searchInput {\n    border: none;\n    height: 30px;\n    width: 100%;\n    max-width: 200px;\n    border-radius: 100px;\n    background: var(--background-color-3-alpha);\n    color: var(--background-color-1);\n    padding: 0 1em;\n    &::placeholder {\n      color: var(--background-color-1);\n      font-style: italic;\n    }\n    &:focus {\n      outline: none;\n    }\n    &:global(.focus-visible) {\n      box-shadow: 0 0 0 5px var(--background-color-1-alpha);\n    }\n  }\n  .searchButton {\n    position: absolute;\n    right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchBar": `SearchBar_searchBar__TMWTY`,
	"searchInput": `SearchBar_searchInput__Tet3F`,
	"searchButton": `SearchBar_searchButton__A9ZIf`
};
export default ___CSS_LOADER_EXPORT___;
